var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("notification-popover", {
    attrs: {
      placement: _vm.isMobile ? "top" : "left",
      disabled: !_vm.showPasswordError,
      "keep-open": _vm.showPasswordError,
      show: _vm.showPasswordError,
    },
    scopedSlots: _vm._u([
      {
        key: "popoverTarget",
        fn: function () {
          return [
            _c("password-input", {
              attrs: {
                "validator-context": _vm.v$.localPassword,
                password: _vm.localPassword,
                placeholder:
                  "" +
                  _vm.$t("account.password") +
                  _vm.$t("account.form.passwordLengthValidation"),
                "on-type": _vm.onType,
                label: _vm.$t("account.password"),
                "signup-client": "",
                "required-indicator": "",
              },
              on: {
                "update:password": function ($event) {
                  _vm.localPassword = $event
                },
                blur: _vm.handlePasswordBlur,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "popoverContent",
        fn: function () {
          return [
            _c(
              "div",
              _vm._l(_vm.rules, function (ref, index) {
                var rule = ref.rule
                var validate = ref.validate
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("icon", {
                      attrs: {
                        name: validate ? "check-circle" : "times-circle",
                        "icon-class": validate ? "text-success" : "text-danger",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { class: { "text-light-gray": !validate } }, [
                      _vm._v("\n          " + _vm._s(rule) + "\n        "),
                    ]),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }